import React from 'react';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../../../../../util/store/selectors';
import { ACTION } from '../../../../../util/varibles/permission';
import Icon, { ICON_NAME } from "../../../../Icon";
import { openNote } from "../../../PopupOpNote";
import styles from "./style.module.scss";

interface IProps {
    isEdit: boolean
    note: string
    operation_code?: string

    handleUpdate?(value: string): void
}

const Note: React.FC<IProps> = (props) => {
    const { note, handleUpdate = () => null, operation_code } = props;
    const [canUpdateOperation] = useSelector(selectPermissions([ACTION.OPERATION.UPDATE]));
    const isEdit = props.isEdit && canUpdateOperation;

    const handleOpenNote = () => {
        openNote({ title: `#${operation_code}`, note, onSave: handleUpdate })
    }

    return <div className={styles['info-note']} data-is-allow={isEdit}>
        {isEdit && <div className={styles.action}>
            <div className={styles.edit} onClick={handleOpenNote}>
                <Icon icon={ICON_NAME.EDIT} />
            </div>
        </div>}
        <div className="flex items-center gap-1">
            <Icon icon={ICON_NAME.NOTE} />
            <span className='font-[600] text-[15px]'>Note</span>
        </div>
        <div className='text-[15px]' onDoubleClick={handleOpenNote} >
            {note}
        </div>
    </div>;
};

export default Note;
